// extracted by mini-css-extract-plugin
export var alertIcon = "_sn-0";